import type { Locale } from '@seek/melways-sites';
import { Text } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import { TimeAgo } from 'src/components/common';
import { APPLIED } from '../../../../constants/sourceId';
import translations from './.vocab';

interface Props {
  appliedDate: string;
  source: number;
  locale: Locale;
}

export const AppliedDate = ({ appliedDate, source, locale }: Props) => {
  const { t } = useTranslations(translations);

  const isSeekApply = source === APPLIED;
  return (
    <Text size="xsmall" tone="secondary">
      <TimeAgo
        date={appliedDate}
        justNowLabel={isSeekApply ? t('Just applied') : t('Just added')}
        actionLabel={isSeekApply ? t('Applied') : t('Manually added')}
        locale={locale}
      />
    </Text>
  );
};
